import Vue from 'vue'
import App from './App'
import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入路由
import VueRouter from 'vue-router';
//引入组件
import 'swiper/dist/css/swiper.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import PayPage from './components/payPage/payPage.vue'

Vue.use(VueAxios,axios);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.use(VueRouter);


const routes=[
  {path:"/",redirect:"/paypage"},
  {path:"/paypage",component:PayPage},
  {path:"*",redirect:"/paypage"}
]
const router = new VueRouter({
   mode: 'history',
   routes,
   linkActiveClass:"active"
  
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js